<template>
  <div class="pillars-navigation">
    <ul>
      <li
        v-for="(indicator, indicatorIndex) in pillarDataConsolidated(pillarId)
          .children"
        :key="indicatorIndex"
        v-b-tooltip.hover
        :class="[
          getColorStateValue(
            indicator.value,
            indicator.ranges,
            indicator.errorOnValueFormula
          ),
          indicator.id === indicatorId ? 'selected' : '',
        ]"
        :title="$t(indicator.name)"
      >
        <router-link
          :to="'/reports/consolidated/' + pillarId + '/' + indicator.id"
        >
          {{ $t(indicator.acronym) }}
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TemplateIndicatorNavigatorConsolidated",
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    indicatorId: {
      type: String,
      default: "PP1",
    },
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters([
      "pillarsIdsConsolidated",
      "pillarDataConsolidated",
      "getColorStateValue",
    ]),
  },
};
</script>
<style lang="sass" scoped>

@import "../../assets/css/variables.scss"

.pillars-navigation
  text-align: center
  font-size: 1.2rem
  display: flex
  justify-content: center
  align-items: center
  font-family: $font-subtitle
  ul
    display: flex
    padding: 0px
    justify-content: center
    margin-top: 20px
    li
      list-style: none
      width: 72px
      height: 40px
      border-radius: 8px
      display: flex
      justify-content: center
      align-items: center
      position: relative
      margin: 0 13px
      &.selected
        height: 47px
        border: 3px #fff solid
        top: -3px
        font-size: 1.4rem
        &:before
          content: " "
          position: absolute
          z-index: -1
          top: -8px
          left: -8px
          right: -8px
          bottom: -8px
          border: 10px solid #000
          border-radius: 12px
      &:after
        content: ''
        position: absolute
        display: block
        background: #8a8989
        width: 100%
        height: 1px
        left: 100%
        z-index: -10
      &:last-child:after
        display: none
      a
        text-decoration: none
        color: #fff
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center

.intermediate a
  color: #000 !important

@media (max-width: 768px)
  .pillars-navigation
    font-size: 1rem
    ul
      li
        width: 50px
        height: 40px
        margin: 0 7px
        &.selected
          font-size: 1.2rem

@media (max-width: 540px)
  .pillars-navigation
    font-size: 0.8rem
    ul
      li
        width: 40px
        height: 40px
        margin: 0 2px
        &.selected
          font-size: 1rem
          border: 1px #fff solid
          &:before
            top: -4px
            left: -4px
            right: -4px
            bottom: -4px
</style>
